import packageInfo from '../../../../package.json';

export const environment = {
  // The company logo upload posts here directly rather than through GraphQL.
  apiUrl: 'https://api.iqd-pro.com',
  production: true,
  version: `v${packageInfo.version}`,
  graphql: {
    uri: 'https://api.iqd-pro.com/graphql',
    wsUri: 'wss://api.iqd-pro.com/graphql',
  },
  auth0: {
    domain: 'auth.iqd-pro.com',
    clientId: 'wESL32OC9X4aYPQM61Bn1Ank0KAySrCJ',
    audience: 'https://api.iqd-pro.com',
    claimsNamespace: 'https://iqd-pro.com/claims/',
    // Auth0's recommended setup for a SPA on a custom domain: renew through a
    // first-party silent-auth iframe and keep nothing renewable in browser
    // storage. Relies on the Auth0 domain being same-site with the app, which
    // holds here — both sit under iqd-pro.com.
    useSilentAuth: true,
  },
  sentry: {
    dsn: 'https://ec169c76049458ddfa4910201c3f7791@o4509351712194560.ingest.de.sentry.io/4509354979885136',
    environment: 'production',
  },
  gtm: {
    id: 'GTM-58ZRKSX',
    enabled: true,
  },
  links: {
    budgetCalculator: 'https://budget.iqd-pro.com',
    viewer3d: 'https://3d-viewer.iqd-pro.com/',
  },
};
